module.exports = {
    chartOption: 
    [{
        credits:{
            enabled: false
        },
        chart: {
            borderWidth: 0,
            borderRadius: 0,
            defaultSeriesType: "spline",
            animation: true,
            marginLeft: 80
            // marginLeft: 200,
            // width: 800,
            // height: 300,
            //id: 1,
        },
        exporting: {
            url: "/export",
            enabled: false
        },
        title: {
            text: "日报曲线",
            style: {
                color: "#000000",
                display: 'block'
            }
        },
        subtitle: {
            text: ""
        },
        legend: {
            enabled: true,
            align: "right",
			verticalAlign: "top",
			floating: false,
			x: 0,
			y: 0
        },
        xAxis: {
            id: "xaxis-1",
            type: "category", //"linear", "logarithmic", "datetime" 或者 "category"之一，分别表示 “线性轴”、“对数轴”、“时间轴”、“分类轴”。
            title:{
                text: "月份",
                enabled: false
            },
            labels: {
                color: "#000"
            },
            gridLineWidth: 0,
            tickInterval: 1,
            tickmarkPlacement: "on",//"on", "between"
            startOnTick: true,
            endOnTick: true,
            min: 0,
            categories:["1月","2月","3月","4月","5月","6月", "7月","8月","9月","10月","11月","12月"]
        },
        yAxis: [
            {
                id: "yaxis-1",
                type: "linear",
                title: {
                    text: "月产油",
                    style: {
                        fontSize: "9px"
                    },
                    x: 0,
                    y: 0
                },
                labels: {
                    color: "#000"
                },
                gridLineWidth: 0,
                startOnTick: true,
                endOnTick: true
            },
            {
                id: "yaxis-2",
                type: "linear",
                title: {
                    text: "月产水",
                    style: {
                        fontSize: "9px"
                    },
                    x: 0,
                    y: 0
                },
                labels: {
                    color: "#000"
                },
                gridLineWidth: 0,
                startOnTick: true,
                endOnTick: true,
                opposite: true
            }
        ],
        series: [{
            id:"series-1",
            yAxis: 0,
            color: "#ff0000",
            name: "月产油",
            lineWidth: 2,
            type: "line",
            marker: {
                enabled: true,                
                symbol: "triangle-down",
                radius: 4
            },
            dataLabels: {
				enabled: true,
                color: "#000000"
			},
            showInLegend: true,
            data: [29.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4]
        },
        {
            id:"series-2",
            yAxis: 1,
            color: "#00ff00",
            name: "月产水",
            lineWidth: 2,
            type: "line",
            marker: {
                enabled: true,
                symbol: "diamond",
                radius: 4
            },
            dataLabels: {
				enabled: true,
                color: "#000000"
			},
            showInLegend: true,
            data: [39.9, 71.5, 46.4, 57.2, 14.0, 76.0, 45.6, 18.5, 116.4, 124.1, 133.6, 154.4]
        }]
    },
    {
        credits:{
            enabled: false
        },
        chart: {
            borderWidth: 0,
            borderRadius: 0,
            defaultSeriesType: "spline",
            animation: true,
            marginLeft: 80
            // marginLeft: 200,
            // width: 800,
            // height: 300,
            //id: 1,
        },
        exporting: {
            url: "/export",
            enabled: false
        },
        title: {
            text: "压力曲线",
            style: {
                color: "#000000",
                display: 'none'
            }
        },
        subtitle: {
            text: ""
        },
        legend: {
            enabled: true,
            align: "right",
			verticalAlign: "top",
			floating: false,
			x: 0,
			y: 0
        },
        xAxis: {
            id: "xaxis-1",
            type: "category", //"linear", "logarithmic", "datetime" 或者 "category"之一，分别表示 “线性轴”、“对数轴”、“时间轴”、“分类轴”。
            title:{
                text: "月份",
                enabled: false
            },
            labels: {
                color: "#000"
            },
            gridLineWidth: 0,
            tickInterval: 1,
            tickmarkPlacement: "on",//"on", "between"
            startOnTick: true,
            endOnTick: true,
            min: 0,
            categories:["1月","2月","3月","4月","5月","6月", "7月","8月","9月","10月","11月","12月"]
        },
        yAxis: [
            {
                id: "yaxis-1",
                type: "linear",
                title: {
                    text: "压力",
                    style: {
                        fontSize: "9px"
                    },
                    x: 0,
                    y: 0
                },
                labels: {
                    color: "#000"
                },
                gridLineWidth: 0,
                startOnTick: true,
                endOnTick: true
            }
        ],
        series: [{
            id:"series-1",
            yAxis: 0,
            color: "#ff0000",
            name: "油压",
            lineWidth: 2,
            type: "column",
            marker: {
                enabled: false,                
                symbol: "triangle-down",
                radius: 4
            },
            dataLabels: {
				enabled: true,
				color: "#000000"
			},
            showInLegend: true,
            data: [29.9, 21.5, 26.4, 29.2, 14.0, 16.0, 15.6, 18.5, 21.4, 19.1, 15.6, 14.4],
            //column
            pointWidth: 20,
            stack: "",
            stacking: "normal"//"normal" "percent" null
        },
        {
            id:"series-2",
            yAxis: 0,
            color: "#00ff00",
            name: "套压",
            lineWidth: 2,
            type: "column",
            marker: {
                enabled: false,
                symbol: "diamond",
                radius: 4
            },
            dataLabels: {
				enabled: true,
				color: "#000000"
			},
            showInLegend: true,
            data: [19.9, 17.5, 16.4, 17.2, 19.0, 20.0, 21.6, 18.5, 16.4, 14.1, 15.6, 14.4],
            //column
            pointWidth: 20,
            stack: "",
			stacking: "normal"//"normal" "percent
        }]
    },{
        credits:{
            enabled: false
        },
        chart: {
            borderWidth: 0,
            borderRadius: 0,
            defaultSeriesType: "spline",
            animation: true,
            marginLeft: 80
            // marginLeft: 200,
            // width: 800,
            // height: 300,
            //id: 1,
        },
        exporting: {
            url: "/export",
            enabled: false
        },
        title: {
            text: "产量构成曲线",
            style: {
                color: "#000000",
                display: 'none'
            }
        },
        subtitle: {
            text: ""
        },
        legend: {
            enabled: true,
            align: "right",
			verticalAlign: "top",
			floating: false,
			x: 0,
			y: 0
        },
        xAxis: {
            id: "xaxis-1",
            type: "category", //"linear", "logarithmic", "datetime" 或者 "category"之一，分别表示 “线性轴”、“对数轴”、“时间轴”、“分类轴”。
            title:{
                text: "月份",
                enabled: false
            },
            labels: {
                color: "#000"
            },
            gridLineWidth: 0,
            tickInterval: 1,
            tickmarkPlacement: "on",//"on", "between"
            startOnTick: true,
            endOnTick: true,
            min: 0,
            categories:["1月","2月","3月","4月","5月","6月", "7月","8月","9月","10月","11月","12月"]
        },
        yAxis: [
            {
                id: "yaxis-1",
                type: "linear",
                title: {
                    text: "月产油",
                    style: {
                        fontSize: "9px"
                    },
                    x: 0,
                    y: 0
                },
                labels: {
                    color: "#000"
                },
                gridLineWidth: 0,
                startOnTick: true,
                endOnTick: true
            }
        ],
        series: [{
            id:"series-1",
            yAxis: 0,
            color: "#FFBB33",
            index: 3,
            name: "老井",
            lineWidth: 2,
            type: "area",
            marker: {
                enabled: false,                
                symbol: "triangle-down",
                radius: 4
            },
            dataLabels: {
				enabled: false,
				color: "#000000"
			},
            showInLegend: true,
            data: [29.9, 31.5, 36.4, 39.2, 44.0, 46.0, 55.6, 58.5, 61.4, 69.1, 73.6, 78.4],
            stack: "",
            stacking: "normal"//"normal" "percent
        },
        {
            id:"series-2",
            yAxis: 0,
            color: "#AA00CC",
            index: 2,
            name: "措施",
            lineWidth: 2,
            type: "area",
            marker: {
                enabled: false,
                symbol: "diamond",
                radius: 4
            },
            dataLabels: {
				enabled: false,
				color: "#000000"
			},
            showInLegend: true,
            data: [0, 0, 0, 0, 0, 10.0, 11.6, 12.5, 14.4, 16.1, 19.6, 24.4],
            stack: "",
			stacking: "normal"//"normal" "percent
        },
        {
            id:"series-3",
            yAxis: 0,
            color: "#FF5B5B",
            index: 1,
            name: "新井",
            lineWidth: 2,
            type: "area",
            marker: {
                enabled: false,
                symbol: "diamond",
                radius: 4
            },
            dataLabels: {
				enabled: false,
				color: "#000000"
			},
            showInLegend: true,
            data: [0, 0, 5.4, 7.2, 9.0, 12.0, 15.6, 18.5, 20.4, 24.1, 25.6, 28.4],
            stack: "",
			stacking: "normal"//"normal" "percent
        }]
    },
        {
            credits:{
                enabled: false
            },
            chart: {
                borderWidth: 0,
                borderRadius: 0,
                defaultSeriesType: "pie",
                animation: true,
                marginLeft: 80,
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                // marginLeft: 200,
                // width: 800,
                // height: 300,
                //id: 1,
            },
            exporting: {
                url: "/export",
                enabled: false
            },
            title: {
                text: "2020年油田区块产油",
                style: {
                    color: "#000000",
                    display: 'none'
                }
            },
            subtitle: {
                text: ""
            },
            legend: {
                enabled: true,
                align: "right",
                verticalAlign: "bottom",
                floating: false,
                x: 0,
                y: 0
            },
            series: [{
                id:"series-1",
                name: '油田采油量',
                type: "pie",
                allowPointSelect: true,
                cursor: 'pointer',
                colorByPoint: true,
                showInLegend: true,
                dataLabels: {
                    enabled: false,
                    color: "#000000"
                },
                data: [{
                    name: '区块1',
                    y: 31.41,
                    sliced: true,
                    selected: true
                }, {
                    name: '区块2',
                    y: 11.84
                }, {
                    name: '区块3',
                    y: 10.85
                }, {
                    name: '区块4',
                    y: 4.67
                }, {
                    name: '区块5',
                    y: 4.18
                }, {
                    name: '区块6',
                    y: 7.05
                }]
            }]
        }]
  }